"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeizeList = void 0;
const complex_data_1 = require("complex-data");
const complex_plugin_1 = require("complex-plugin");
const dictionary_1 = require("@/config/dictionary");
const layout_1 = __importDefault(require("@/config/utils/layout"));
const config_1 = require("@/config/dictionary/config");
const litigation_1 = __importDefault(require("@/pages/index/api/litigation"));
const select_1 = require("@/pages/index/select");
const dict_1 = require("@/pages/index/select/dict");
const litigation_2 = require("@/pages/index/select/litigation");
const operateLog_1 = require("@/pages/index/utils/operateLog");
class SeizeList extends complex_data_1.ComplexList {
    buildItem(postData) {
        return new Promise((resolve, reject) => {
            postData.litigationRecordId = this.$getExtra('litigationRecordId');
            litigation_1.default.litigationSeizeBuild.require(postData).then(() => {
                complex_plugin_1.notice.showMsg('法诉查封申请成功！', 'success');
                const next = litigation_2.seizeStatus.getIndex(0);
                (0, operateLog_1.pushOperateLog)(postData.litigationRecordId, '发起' + next.label, 'litigationRecord');
                this.$reloadData(true);
                resolve({ status: 'success' });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    }
    changeItem(postData, payload, originData) {
        return new Promise((resolve, reject) => {
            postData.id = originData.id;
            postData.taskId = payload.id;
            litigation_1.default.litigationSeizeChange.require(postData).then(() => {
                complex_plugin_1.notice.showMsg('法诉查封申请审批成功！', 'success');
                const currentStatus = originData.status.value;
                const next = litigation_2.seizeStatus.getRelation(currentStatus, 1);
                if (next) {
                    (0, operateLog_1.pushOperateLog)(originData.litigationRecordId, '维护' + next.label, 'litigationRecord');
                }
                resolve({ status: 'success' });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    }
    rejectItem(postData, payload, originData) {
        return new Promise((resolve, reject) => {
            postData.id = originData.id;
            postData.taskId = payload.id;
            litigation_1.default.litigationSeizeReject.require(postData).then(() => {
                complex_plugin_1.notice.showMsg('法诉查封申请驳回完成！', 'success');
                resolve({ status: 'success' });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    }
    refuseItem(postData, payload, originData) {
        return new Promise((resolve, reject) => {
            postData.id = originData.id;
            postData.taskId = payload.id;
            litigation_1.default.litigationSeizeRefuse.require(postData).then(() => {
                complex_plugin_1.notice.showMsg('法诉查封申请拒绝完成！', 'success');
                resolve({ status: 'success' });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    }
}
exports.SeizeList = SeizeList;
const layoutParse = new layout_1.default(2, 8, 16);
const seizeList = new SeizeList({
    name: '查封申请',
    prop: 'seizeList',
    module: {
        dictionary: {
            layout: {
                default: layoutParse.getData(2)
            },
            option: {},
            propData: {
                id: 'id'
            },
            list: [
                {
                    prop: 'id',
                    name: 'ID',
                    originProp: 'id',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'litigationRecordId',
                    name: '法诉记录ID',
                    originProp: 'litigationRecordId',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'code',
                    name: '申请编号',
                    originProp: 'code',
                    originFrom: 'list',
                    mod: {
                        list: {}
                    }
                },
                {
                    prop: 'applyUserId',
                    name: '无',
                    originProp: 'applyUserId',
                    originFrom: 'list',
                    mod: {}
                },
                (0, dictionary_1.buildDictionaryBySelect)(litigation_2.seizeStatus, {
                    prop: 'status',
                    name: '查封状态',
                    originProp: 'taskDefKey',
                    originFrom: 'list',
                    mod: {
                        list: {}
                    }
                }),
                (0, dictionary_1.buildDictionaryBySelect)(select_1.ApprovalStatus, {
                    prop: 'applyStatus',
                    name: '审批状态',
                    originProp: 'applyStatus',
                    originFrom: 'list',
                    mod: {
                        list: {}
                    }
                }),
                {
                    prop: 'passTime',
                    name: '无',
                    originProp: 'passTime',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'deploymentId',
                    name: '无',
                    originProp: 'deploymentId',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'procInsId',
                    name: '无',
                    originProp: 'procInsId',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'applyComment',
                    name: '无',
                    originProp: 'applyComment',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'taskId',
                    name: '无',
                    originProp: 'taskId',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'seizeType',
                    name: '查封类型',
                    originProp: 'seizeType',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'seizeContent',
                    name: '查封内容',
                    originProp: 'seizeContent',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'seizeApplyTime',
                    name: '查封申请时间',
                    originProp: 'seizeApplyTime',
                    originFrom: 'list',
                    mod: {
                        edit: {
                            type: 'date',
                            required: true
                        },
                        ufo_cs_zx_40: {
                            $target: 'edit'
                        }
                    }
                },
                (0, dictionary_1.buildDictionaryBySelect)(dict_1.dict.LitigationSeizeUnsealReason, {
                    prop: 'unsealReason',
                    name: '解封原因',
                    originProp: 'unsealReason',
                    originFrom: 'list',
                    mod: {
                        edit: {
                            required: true
                        },
                        ufo_cs_cf_50: {
                            $target: 'edit'
                        }
                    }
                }),
                (0, dictionary_1.buildDictionaryBySelect)(dict_1.dict.LitigationSeizeUnsealContent, {
                    prop: 'unsealContent',
                    name: '解封内容',
                    originProp: 'unsealContent',
                    originFrom: 'list',
                    mod: {
                        edit: {
                            required: true
                        },
                        ufo_cs_cf_50: {
                            $target: 'edit'
                        }
                    }
                }),
                {
                    prop: 'remark',
                    name: '无',
                    originProp: 'remark',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'createdBy',
                    name: '无',
                    originProp: 'createdBy',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'createdName',
                    name: '创建人',
                    originProp: 'createdName',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.personnelName
                        }
                    }
                },
                {
                    prop: 'createdTime',
                    name: '创建时间',
                    originProp: 'createdTime',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.time
                        }
                    }
                },
                {
                    prop: 'updatedBy',
                    name: '无',
                    originProp: 'updatedBy',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'updatedTime',
                    name: '无',
                    originProp: 'updatedTime',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'menu',
                    name: '操作',
                    originProp: 'menu',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.getWidth(2)
                        }
                    }
                },
            ]
        }
    },
    $getData() {
        return new Promise((resolve, reject) => {
            litigation_1.default.litigationSeize.require(Object.assign(Object.assign({}, this.$getSearch()), { litigationRecordId: this.$getExtra('litigationRecordId'), pageNo: this.$getPageData('current'), pageSize: this.$getPageData('size') })).then(res => {
                this.$formatList(res.data.data, res.data.totalCount);
                resolve({ status: 'success' });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    }
});
exports.default = seizeList;
